import React from 'react';
import Input from './Input';
import getFormData from 'get-form-data';
import Select from './../../modules/select.js';
import UpdateMarkerScorecard from './../../modules/scorecard-marker-update.js';
import { map } from 'lodash';

export default React.createClass({
    propTypes: {
        dataUrl: React.PropTypes.string.isRequired,
        postUrl: React.PropTypes.string.isRequired,
        cancelUrl: React.PropTypes.string.isRequired,
        resultPageUrl: React.PropTypes.string.isRequired,
        courseId: React.PropTypes.string.isRequired,
        teeId: React.PropTypes.string.isRequired,
        loopId: React.PropTypes.string.isRequired,
		qualifying: React.PropTypes.string.isRequired,
		competition: React.PropTypes.string.isRequired,
		remark: React.PropTypes.string,
        markerId: React.PropTypes.string,
        customMarker: React.PropTypes.string,
        scorecardId: React.PropTypes.string,
        date: React.PropTypes.string,
        isNoReturn: React.PropTypes.string,
        cardNumber: React.PropTypes.string,
        i18n: React.PropTypes.object
    },
    getInitialState() {
        return {
            data: [],
            total: [],
            selected: [], // selected[index] == true if item with given index is currently selected
            formSent: false,
            submitting: false,
            error: false
        };
    },
    componentWillMount() {
        const context = this;

        const params = {
            courseId: this.props.courseId,
            teeId: this.props.teeId,
            loopId: this.props.loopId,
			qualifying: this.props.qualifying,
			competition: this.props.competition,
			remark: this.props.remark,
            markerId: this.props.markerId,
            customMarker: this.props.customMarker,
            scorecardId: this.props.scorecardId,
            date: this.props.date,
            cardNumber: this.props.cardNumber,
            isNoReturn: this.props.isNoReturn
        };

        this.serverRequest = $.get(context.props.dataUrl, params, (result) => {
            if (result.Error) {
                this.setState({
                    error: result.Error
                });
            } else {
                const 
                    data = {
                        ...result,
                        ScoreCard: {
                            ...result.ScoreCard,
                            Scores: 
                                result.ScoreCard.Scores.map((score, index) => ({
                                    ...score,
                                    isDisabled: index !== 0 
                                }))
                        }
                    }

                this.setState({
                    data: data,
                    error: false
                });
            }
        }).fail(() => {
            this.setState({
                error: this.props.i18n.loadError
            })
            dataLayer.push({
                'event': 'scorecard_create_error',
                'eventCategory': 'scoreCard',
                'eventAction': 'create',
                'eventLabel': 'error',
                'error_type': 'server_error'
            }); 
        });
    },
    componentWillUnmount: function() {
        this.serverRequest.abort();
    },
    handleInputChange: function(index, count) {
        
        const 
            scores = this.state.data.ScoreCard.Scores.map(score => score.NumberOfStrokes);
        
        scores[index] = count;

        const
            firstEmptyIndex = scores.findIndex(score => score === 0),
            lastEnabledIndex = firstEmptyIndex === -1 ? scores.length - 1 : firstEmptyIndex;
        
        function determinateScore(score, scoreIndex) {
            if (scoreIndex === index) {
                return count;
            }
            return scoreIndex > lastEnabledIndex ? 0 : score.NumberOfStrokes;
        }

        const data = {
            ...this.state.data,
            ScoreCard: {
                ...this.state.data.ScoreCard,
                Scores: 
                    this.state.data.ScoreCard.Scores.map((score, scoreIndex) => ({
                        ...score,
                        NumberOfStrokes: determinateScore(score, scoreIndex),
                        isDisabled: scoreIndex > lastEnabledIndex
                    }))
                }
            }

        this.setState({
            data: data
        });        
    },
    handleClick(idx) {
        var newSelected = [];
        newSelected[idx] = true;      
        this.setState({
            selected: newSelected
        });
    },
    handleMarkerChange(e) {
        // The selection of the dropdown is not included in the post, by default. If a different marker is selected, this property is set to post the change.
        this.state.data['NewMarkerId'] = $(e.target).val();
    },
    onCancel() {
        dataLayer.push({
            'event': 'scorecard_cancel',
            'course': this.state.data.CourseName,
            'holes': this.state.data.LoopName,
            'tee': this.state.data.TeeName,
            'Qualifying': this.state.data.ScoreCard.IsQualifying,
            'eventCategory': 'scoreCard',
            'eventAction': 'cancel',
            'eventLabel': '',
        });
        document.location = this.props.cancelUrl;
    },
    onSubmit(e) {
        const 
            formData = getFormData(e.target),
            data = this.state.data,
            firstNineHoles = Object.keys(formData).slice(0, 9).every(key => !isNaN(parseInt(formData[key], 10)));

        this.setState({
            error: false,
            submitting: true
        });    

        if(firstNineHoles === false) {
            alert(this.props.i18n.minHoles);
        }
        
        _.each(formData, function(value, key) {
            // strip 'id' from the input name
            key = Number(key.replace('id', ''));
            if (!isNaN(key)) {
                const 
                    score = _.find(data.ScoreCard.Scores, { Hole: { Id: key } }),
                    parsedValue = parseInt(value, 10),
                    numberOfStrokes = isNaN(parsedValue) ? 0 : parsedValue;
                score.Hole.IsPlayed = numberOfStrokes === 0 ? false : true;
				score.NumberOfStrokes = numberOfStrokes;
            }
        });

        if(firstNineHoles) {
            const  
                scores = data.ScoreCard.Scores.map(score => score.NumberOfStrokes),
                firstEmptyHole = scores.findIndex(score => score === 0),  
                i18nConfirm = this.props.i18n.confirm,
                i18nNumberOfHolesPlayed = this.props.i18n.confirmNumberOfHolesPlayed,
                replacedI18nNumberOfHolesPlayed = i18nNumberOfHolesPlayed.replace('{numberOfHoles}', firstEmptyHole),
                allHolesPlayed = firstEmptyHole === -1,
                confirmMessage = allHolesPlayed ? i18nConfirm : replacedI18nNumberOfHolesPlayed;

            if (confirm(confirmMessage)) {
                $.ajax({
                    url: this.props.postUrl,
                    dataType: 'json',
                    type: 'POST',
                    data: { json : JSON.stringify(data) },
                    success: (res) => {
                        if (res.Error) {
                            window.scrollTo(0, 0);
                            this.setState({
                                error: res.Error,
                                submitting: false
                            });
                        } else {
                            this.setState({
                                formSent: true,
                                selected: [],
                                submitting: false
                            });
                            dataLayer.push({
                                'event': 'scorecard_finish',
                                'course': data.CourseName,
                                'holes': data.LoopName,
                                'tee' : data.TeeName,
                                'Qualifying': data.ScoreCard.IsQualifying,
                                'eventCategory': 'scorecard',
                                'eventAction': 'finished',
                                'eventLabel': 'finished',
                            }); 
                            // redirect to results page
                            document.location = this.props.resultPageUrl+'?scoreCardId='+res.Id;
                        }
                    }
                }).fail(() => {
                    window.scrollTo(0, 0);
                    this.setState({
                        submitting: false,
                        error: this.props.i18n.submitError
                    })
                    dataLayer.push({
                        'event': 'scorecard_create_error',
                        'eventCategory': 'scoreCard',

                        'eventAction': 'create',
                        'eventLabel': 'error',
                        'error_type': 'server_error'
                    });
                });
            } else {
                this.setState({
                    submitting: false
                });                
            }   
        }
        else {
            this.setState({
                submitting: false
            });
        }
        e.preventDefault();
    },
    render() {
        var context = this;

        if (_.isEmpty(this.state.data)) {
            return (
                <div className="c-spinner">{this.props.i18n.loading}</div>
            );
        } else if (this.state.formSent) {
            return (
                <div>{this.props.i18n.success}</div>
            );
        }

        const buttonLoadingClass = (this.state.submitting) ? 'is-loading' : '';

        // check if this is a rejected card or not
        const isRejected = (this.props.scorecardId || this.props.scorecardId !== '') ? true : false;

        return (
            <form ref="form" onSubmit={this.onSubmit}>
            {this.state.error && <div className="c-feedback -error">{this.state.error}</div>}
            <div className="c-scorecard-details">
                <div className="c-scorecard-details__group">
                    <div className="c-scorecard-details__label">{this.props.i18n.course}:</div>
                    <div className="c-scorecard-details__text">{this.state.data.CourseName}</div>
                </div>
                {!isRejected &&
                <div className="c-scorecard-details__group">
                    <div className="c-scorecard-details__label">{this.props.i18n.holes}:</div>
                    <div className="c-scorecard-details__text">{this.state.data.LoopName}</div>
                </div>}
                {!isRejected &&
                <div className="c-scorecard-details__group">
                    <div className="c-scorecard-details__label">{this.props.i18n.tee}:</div>
                    <div className="c-scorecard-details__text">{this.state.data.TeeName}</div>
                </div>}
                {!isRejected &&
                    <div className="c-scorecard-details__group">
                    <div className="c-scorecard-details__label">{this.props.i18n.phcp}:</div>
                        <div className="c-scorecard-details__text">{this.state.data.ScoreCard.PlayingHandicap}</div>
                    </div>}
                {isRejected &&
                <div className="c-scorecard-details__group">
                    <div className="c-scorecard-details__label">{this.props.i18n.marker}:</div>
                    <div className="c-scorecard-details__text">
                            <select id="input-marker" name="markerId" className="js-select2 js-select2-marker js-marker-input"
                                data-url="/api/mygame/findmarker"
                                data-updatemarker-url="/api/mygame/updatemarker"
                                data-rule-required="true"
                                data-msg-required="Marker is verplicht"
                                data-defaultphotourl="/assets/mijngolf/img/profile-picture-default.png"
                                data-i18n-placeholder="Selecteer een marker"
                                data-i18n-noresults="Geen marker gevonden."
                                data-i18n-searching="Zoeken..."
                                onChange={this.handleMarkerChange}>
                            <option value={this.state.data.ScoreCard.Marker.Id} className="js-default-value">{this.state.data.ScoreCard.Marker.FullName}</option>
                        </select>
                    </div>
                </div>}
                {isRejected &&
                <div className="c-scorecard-details__group">
                    <div className="c-scorecard-details__label">{this.props.i18n.motivation}:</div>
                    <div className="c-scorecard-details__text">{this.state.data.ScoreCard.Comment}</div>
                </div>}
            </div >
                <div className="c-scorecard__scores__inner">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Hole</th>
                                        <th>Par<sup>+Ik</sup></th>
                                        <th>Slagen</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {map(this.state.data.ScoreCard.Scores, (model, idx) => {
                                        return <Input
                                            ref="input"
                                            key={model.Hole.Id}
                                            index={idx}
                                            id={model.Hole.Id}
											par={model.Hole.Par}
											isPlayed={model.Hole.IsPlayed}
                                            personalPar={model.Hole.PersonalPar}
                                            tabIndex={idx}
                                            numberOfStrokes={model.NumberOfStrokes}
                                            onClick={context.handleClick}
                                            selected={context.state.selected[idx] !== undefined}
                                            onChange={context.handleInputChange}
                                            defaultInputValue={context.props.i18n.defaultInputValue}
                                            isDisabled={model.isDisabled}
                                            />;
                                    })}
                                    <tr className="is-total">
                                        <td colSpan="2">Totaal</td>
                                        <td>{_.sum(this.state.data.ScoreCard.Scores.map(score => score.NumberOfStrokes))}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                <div className="c-form__buttons">
                    {!isRejected &&
                        <a href="javascript:void(0)" onClick={context.onCancel} className="c-button c-button--secondary c-form__buttons__button">
                            <span>
                                <div className="c-button__text">{this.props.i18n.cancelButtonText}</div>
                            </span>
                        </a>
                    }
                    <button type="submit" className={`c-button c-form__buttons__button ${buttonLoadingClass}`} disabled={this.state.submitting}>
                        <span>{isRejected ? this.props.i18n.editButtonText : this.props.i18n.submitButtonText}</span>
                    </button>
                </div>
            </form>
        );
    },
    componentDidUpdate() {
        $('.js-form-update-marker-scorecard:not(".js-updated")').each(function () {
            $(this).addClass('js-updated');
            new UpdateMarkerScorecard($(this));
            new Select();
        });

        $('#input-marker').on("change", this.handleMarkerChange);
    }
});
